import { supabase, isSupabaseConfigured, uploadComprobante, submitTestimonial, getClientPublicInfo } from './supabaseClient.js';
import { showRetroAlert } from './retroAlert.js';

document.addEventListener('DOMContentLoaded', async () => {
  const urlParams = new URLSearchParams(window.location.search);
  let clientId = urlParams.get('id');

  const gateLoading = document.getElementById('gate-loading');
  const gateAccessDenied = document.getElementById('gate-access-denied');
  const gateAlreadySubmitted = document.getElementById('gate-already-submitted');
  const gateSurvey = document.getElementById('gate-survey');
  const alreadySubmittedDetails = document.getElementById('already-submitted-details');

  const clientBanner = document.getElementById('client-banner');
  const clientInfoText = document.getElementById('client-info-text');
  const feedbackForm = document.getElementById('feedback-form');
  const starsContainer = document.getElementById('stars-selector');
  const calificacionInput = document.getElementById('calificacion');
  const fileInput = document.getElementById('comprobante-file');
  const filePreview = document.getElementById('file-preview');
  const previewImg = document.getElementById('preview-img');
  const removeFileBtn = document.getElementById('remove-file-btn');
  const submitBtn = document.getElementById('submit-btn');
  const statusMsg = document.getElementById('status-msg');
  const successModal = document.getElementById('success-modal');

  // Input manual opcional de ID en pantalla de acceso restringido
  const manualIdInput = document.getElementById('manual-client-id');
  const validateManualIdBtn = document.getElementById('validate-manual-id-btn');

  function handleManualIdSubmit() {
    if (!manualIdInput) return;
    let val = manualIdInput.value.trim();
    if (!val) return;
    // Si pegaron una URL completa tipo https://...?id=UUID extraer el id
    if (val.includes('id=')) {
      try {
        const u = new URL(val.startsWith('http') ? val : `http://localhost/${val}`);
        val = u.searchParams.get('id') || val;
      } catch {
        // mantener val
      }
    }
    window.location.href = `/feedback.html?id=${encodeURIComponent(val)}`;
  }

  if (validateManualIdBtn) {
    validateManualIdBtn.addEventListener('click', handleManualIdSubmit);
  }
  if (manualIdInput) {
    manualIdInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleManualIdSubmit();
      }
    });
  }

  // =========================================================================
  // 1. CONTROL DE ACCESO ESTRICTO POR CLIENTE
  // =========================================================================
  if (!clientId || clientId.trim() === '') {
    // CASO 1: Visita anónima sin link personalizado -> Acceso Restringido
    if (gateLoading) gateLoading.classList.add('hidden');
    if (gateAccessDenied) gateAccessDenied.classList.remove('hidden');
    return;
  }

  clientId = clientId.trim();

  // Consultar cliente en el kernel de Supabase
  let client = null;
  try {
    client = await getClientPublicInfo(clientId);
  } catch (err) {
    console.warn('Error al verificar cliente en Supabase:', err);
  }

  // Soporte demo/offline si no hay conexión a Supabase o parámetro demo (?id=demo o ?id=demo-uuid-client)
  const isDemoParam = clientId.toLowerCase() === 'demo' || clientId.toLowerCase() === 'demo-uuid-client' || clientId.toLowerCase().startsWith('demo');
  if (!client && (!isSupabaseConfigured || isDemoParam)) {
    if (isDemoParam) {
      client = {
        id: 'demo-uuid-client',
        nombre_completo: 'Gamer Verificado (Demo)',
        cuenta_asignada: 'demo@instaplay.latam',
        racha_meses: 2,
        pais: 'Perú',
        encuesta_15d_enviada: false,
        fecha_inicio: '2026-08-01'
      };
    }
  }

  if (gateLoading) gateLoading.classList.add('hidden');

  const gateWaiting15d = document.getElementById('gate-waiting-15d');
  const waitingDaysBadge = document.getElementById('waiting-days-badge');
  const waitingDaysDetails = document.getElementById('waiting-days-details');

  // CASO 2: ID inexistente o manipulado en URL
  if (!client) {
    if (gateAccessDenied) {
      gateAccessDenied.classList.remove('hidden');
      const errorTag = gateAccessDenied.querySelector('.font-mono.text-xs');
      if (errorTag) {
        errorTag.textContent = 'ERROR 404: CLIENTE_NO_LOCALIZADO_EN_KERNEL';
      }
      const desc = gateAccessDenied.querySelector('p');
      if (desc) {
        desc.innerHTML = `
          El identificador <code class="text-yellow-300 font-mono">[${clientId.substring(0, 18)}...]</code> no corresponde a ningún cliente activo en el sistema. 
          Verifica que hayas copiado el enlace completo enviado por WhatsApp o solicita uno nuevo a soporte.
        `;
      }
    }
    return;
  }

  // CASO 2.5: REQUISITO ESTRICTO DE 15 DÍAS MÍNIMOS CON EL SERVICIO ACTIVO
  const simDiasParam = urlParams.get('sim_dias');
  const simEnviadaParam = urlParams.get('sim_enviada') === 'true';
  const isExplicitTestBypass = urlParams.get('test') === 'true';

  let diasActivo = 15;
  if (simDiasParam !== null) {
    diasActivo = parseInt(simDiasParam, 10);
  } else if (client.fecha_inicio) {
    const fInicio = new Date(client.fecha_inicio + 'T00:00:00');
    const hoy = new Date();
    const diffTime = hoy.getTime() - fInicio.getTime();
    diasActivo = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  }

  // 1. Bloqueo de 15 días:
  // - Si se envió sim_dias expresamente (< 15), SIEMPRE se bloquea para probar la simulación
  // - Si no se envió sim_dias y diasActivo < 15, se bloquea a menos que se use &test=true
  const shouldBlock15d = (simDiasParam !== null && diasActivo < 15) || 
                         (simDiasParam === null && diasActivo < 15 && !isExplicitTestBypass && !isDemoParam);

  if (shouldBlock15d) {
    if (gateWaiting15d) {
      if (waitingDaysBadge) {
        waitingDaysBadge.textContent = `DÍA ${Math.max(0, diasActivo)} DE 15 REQUERIDOS`;
      }
      if (waitingDaysDetails) {
        const diasRestantes = Math.max(1, 15 - diasActivo);
        waitingDaysDetails.innerHTML = `
          ¡Hola <strong class="text-white">${client.nombre_completo.toUpperCase()}</strong>! 👋<br/><br/>
          Tu suscripción lleva actualmente <strong class="text-yellow-400">${Math.max(0, diasActivo)} día(s) activa</strong> (Fecha de registro: ${client.fecha_inicio || 'Reciente'}).<br/><br/>
          Por estrictas políticas de auditoría y calidad de InstaPlay Latam, la encuesta y la acreditación de <strong class="text-[#39ff14]">5% DE DESCUENTO</strong> se habilitan automáticamente a partir del <strong>DÍA 15</strong> de tu suscripción para garantizar que tu reseña se base en horas reales de juego y estabilidad comprobada.<br/><br/>
          <span class="text-cyan-300">⏳ Te faltan <strong>${diasRestantes} día(s)</strong> para desbloquear tu formulario y reclamar tu 5% de descuento en tu renovación.</span>
        `;
      }
      gateWaiting15d.classList.remove('hidden');
    }
    if (gateSurvey) gateSurvey.classList.add('hidden');
    return;
  }

  // CASO 3: Cliente ya respondió anteriormente la encuesta (o simulación 'done' / sim_enviada=true)
  const isAlreadySubmitted = Boolean(client.encuesta_15d_enviada || simEnviadaParam);
  if (isAlreadySubmitted) {
    if (gateAlreadySubmitted) {
      if (alreadySubmittedDetails) {
        alreadySubmittedDetails.innerHTML = `
          ¡Hola <strong class="text-white">${client.nombre_completo.toUpperCase()}</strong>! 👋<br/><br/>
          Ya registramos tu testimonio anteriormente y tu <strong class="text-[#39ff14]">5% DE DESCUENTO</strong> fue acreditado a tu cuenta <strong class="text-cyan-400">[${client.cuenta_asignada || 'ACTIVA'}]</strong> para tu próxima renovación.
        `;
      }
      gateAlreadySubmitted.classList.remove('hidden');
    }
    if (gateSurvey) gateSurvey.classList.add('hidden');
    return;
  }

  // CASO 4: Cliente válido y encuesta pendiente -> Desbloquear Formulario
  if (gateSurvey) gateSurvey.classList.remove('hidden');

  document.getElementById('cliente_id').value = client.id;
  if (clientBanner && clientInfoText) {
    clientBanner.classList.remove('hidden');
    clientInfoText.innerHTML = `
      🎮 JUGADOR VERIFICADO: <span class="text-[#39ff14] font-bold">${client.nombre_completo.toUpperCase()}</span> | 
      CUENTA: <span class="text-cyan-400 font-mono">${client.cuenta_asignada || 'ACTIVA'}</span> | 
      RACHA ACTUAL: <span class="text-yellow-400 font-bold">${client.racha_meses || 1} MES(ES) 🔥</span>
    `;
  }

  if (client.pais) {
    const paisSelect = document.getElementById('pais');
    if (paisSelect) {
      paisSelect.value = client.pais;
    }
  }

  const gamertagInput = document.getElementById('gamertag');
  if (gamertagInput && !gamertagInput.value) {
    const cleanNick = client.nombre_completo.replace(/\s+/g, '').toLowerCase();
    gamertagInput.placeholder = `Ej: @${cleanNick} / ${client.nombre_completo.split(' ')[0]}`;
  }

  // =========================================================================
  // 2. SELECTOR INTERACTIVO DE ESTRELLAS
  // =========================================================================
  let currentRating = 5;
  function renderStars(rating) {
    const starButtons = starsContainer.querySelectorAll('.star-btn');
    starButtons.forEach((btn, idx) => {
      if (idx < rating) {
        btn.classList.add('text-yellow-400');
        btn.classList.remove('text-gray-600');
        btn.textContent = '★';
      } else {
        btn.classList.remove('text-yellow-400');
        btn.classList.add('text-gray-600');
        btn.textContent = '☆';
      }
    });
    calificacionInput.value = rating;
    const ratingLabel = document.getElementById('rating-label');
    if (ratingLabel) {
      ratingLabel.textContent = `[ ${rating} / 5 ESTRELLAS ]`;
    }
  }

  starsContainer.addEventListener('click', (e) => {
    const btn = e.target.closest('.star-btn');
    if (!btn) return;
    currentRating = parseInt(btn.dataset.value, 10) || 5;
    renderStars(currentRating);
  });
  renderStars(currentRating);

  // =========================================================================
  // 3. ADJUNTAR COMPROBANTE / CAPTURA DE WHATSAPP
  // =========================================================================
  let selectedFile = null;

  fileInput.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      showRetroAlert('Por favor selecciona un formato de imagen válido (JPG, PNG o WEBP).', {
        title: 'FORMATO INVÁLIDO',
        type: 'warning',
        badgeText: '[ ARCHIVO NO COMPATIBLE ]'
      });
      fileInput.value = '';
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      showRetroAlert('La captura seleccionada supera el límite máximo de 5MB.\n\nPor favor adjunta una imagen más ligera o comprimida.', {
        title: 'ARCHIVO MUY GRANDE',
        type: 'warning',
        badgeText: '[ LÍMITE DE TAMAÑO EXCEDIDO ]'
      });
      fileInput.value = '';
      return;
    }

    selectedFile = file;
    const reader = new FileReader();
    reader.onload = (event) => {
      previewImg.src = event.target.result;
      filePreview.classList.remove('hidden');
    };
    reader.readAsDataURL(file);
  });

  removeFileBtn.addEventListener('click', () => {
    selectedFile = null;
    fileInput.value = '';
    previewImg.src = '';
    filePreview.classList.add('hidden');
  });

  // =========================================================================
  // 3.1. CONTADOR DINÁMICO DE CARACTERES (MÁX 260 CARACTERES)
  // =========================================================================
  const testimonioInput = document.getElementById('testimonio_texto');
  const charCounter = document.getElementById('char-counter');
  const charRemainingHint = document.getElementById('char-remaining-hint');

  if (testimonioInput) {
    const updateCharCounter = () => {
      const currentLength = testimonioInput.value.length;
      const maxLength = 260;
      const remaining = maxLength - currentLength;

      if (charCounter) {
        charCounter.textContent = `${currentLength} / ${maxLength}`;
        if (remaining < 20) {
          charCounter.className = 'text-xs font-mono text-red-400 font-bold tracking-wider animate-pulse';
        } else if (remaining < 50) {
          charCounter.className = 'text-xs font-mono text-yellow-400 font-bold tracking-wider';
        } else {
          charCounter.className = 'text-xs font-mono text-green-400 font-bold tracking-wider';
        }
      }

      if (charRemainingHint) {
        if (remaining === 0) {
          charRemainingHint.textContent = '¡Límite de 260 caracteres alcanzado!';
          charRemainingHint.className = 'text-red-400 font-bold';
        } else {
          charRemainingHint.textContent = `${remaining} caracteres disponibles`;
          charRemainingHint.className = remaining < 20 ? 'text-red-400 font-bold' : (remaining < 50 ? 'text-yellow-400' : 'text-green-400/80');
        }
      }
    };

    testimonioInput.addEventListener('input', updateCharCounter);
    testimonioInput.addEventListener('keyup', updateCharCounter);
    testimonioInput.addEventListener('paste', () => setTimeout(updateCharCounter, 10));
    updateCharCounter();
  }

  // =========================================================================
  // 4. TRANSMISIÓN DEL FEEDBACK AL KERNEL
  // =========================================================================
  feedbackForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (shouldBlock15d) {
      showRetroAlert('Acceso denegado: Tu suscripción aún no cumple los 15 días mínimos requeridos para responder la encuesta.', {
        title: 'REQUISITO NO CUMPLIDO',
        type: 'warning',
        badgeText: '[ DÍA 15 REQUERIDO ]'
      });
      return;
    }

    if (isAlreadySubmitted) {
      showRetroAlert('Esta encuesta ya ha sido registrada anteriormente y tu 5% de descuento fue acreditado.', {
        title: 'ENCUESTA YA ENVIADA',
        type: 'info',
        badgeText: '[ YA REGISTRADA ]'
      });
      return;
    }

    const rawTestimonio = (testimonioInput ? testimonioInput.value : '').trim();
    if (rawTestimonio.length > 260) {
      showRetroAlert(`Tu testimonio tiene ${rawTestimonio.length} caracteres y supera el límite de 260.\n\nPor favor acórtalo un poco para que se visualice correctamente en la vitrina gamer.`, {
        title: 'LÍMITE DE CARACTERES EXCEDIDO',
        type: 'warning',
        badgeText: '[ MÁXIMO 260 CARACTERES ]'
      });
      return;
    }

    submitBtn.disabled = true;
    submitBtn.innerHTML = `
      <span class="inline-block animate-spin mr-2">⟳</span> TRANSMITIENDO DATOS AL KERNEL...
    `;
    statusMsg.classList.remove('hidden');
    statusMsg.className = 'text-center font-mono text-sm text-[#00ff41]';
    statusMsg.textContent = '[1/2] Procesando testimonio y parámetros técnicos...';

    try {
      let comprobanteUrl = null;

      // Subir imagen si seleccionó archivo
      if (selectedFile) {
        statusMsg.textContent = '[1/2] Subiendo comprobante a Cloudinary CDN (Auto-Optimizado)...';
        try {
          comprobanteUrl = await uploadComprobante(selectedFile);
        } catch (uploadErr) {
          console.warn('Fallo al subir comprobante a Cloudinary:', uploadErr);
        }
      }

      statusMsg.textContent = '[2/2] Guardando testimonio y acreditando 5% de descuento...';

      const payload = {
        cliente_id: document.getElementById('cliente_id').value || client.id,
        gamertag: document.getElementById('gamertag').value.trim(),
        perfil_social_link: document.getElementById('perfil_social_link').value.trim(),
        ciudad_pais: document.getElementById('pais') ? document.getElementById('pais').value : (client.pais || 'Perú'),
        calificacion_estrellas: parseInt(calificacionInput.value, 10) || 5,
        juegos_mencionados: document.getElementById('juegos_mencionados').value.trim(),
        dispositivo_red: document.getElementById('dispositivo_red').value.trim(),
        testimonio_texto: document.getElementById('testimonio_texto').value.trim(),
        comprobante_captura_url: comprobanteUrl,
        insignia_verificacion: document.getElementById('metodo_pago').value || 'PAGO_VERIFICADO_YAPE',
        racha_al_publicar: client.racha_meses || 1
      };

      // Registrar testimonio (guarda en caché local e intenta sincronizar con Supabase)
      await submitTestimonial(payload);

      // Ocultar formulario y mostrar modal de éxito
      if (gateSurvey) gateSurvey.classList.add('hidden');
      successModal.classList.remove('hidden');
      feedbackForm.reset();
      filePreview.classList.add('hidden');
      selectedFile = null;
      statusMsg.classList.add('hidden');

    } catch (err) {
      console.error('Error al enviar testimonio:', err);
      statusMsg.className = 'text-center font-mono text-sm text-red-400';
      statusMsg.textContent = `[ERROR DE TRANSMISIÓN]: ${err.message || 'Intente nuevamente'}`;
      showRetroAlert(`No fue posible transmitir tu testimonio: ${err.message || 'Error de conexión'}.\n\nPor favor intenta nuevamente.`, {
        title: 'ERROR DE TRANSMISIÓN',
        type: 'danger',
        badgeText: '[ FALLO AL CONECTAR ]'
      });
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = `<span>⚡ ENVIAR FEEDBACK Y ACTIVAR 5% DE DESCUENTO</span>`;
    }
  });
});
